import { IonContent, IonHeader, IonPage, IonTitle, IonToolbar, IonButtons, IonMenuButton, IonBackButton } from '@ionic/react';
import CreateLeadOrder from '../components/CreateLeadOrder';

const Order: React.FC = () => {
    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonBackButton />
                        <IonMenuButton />
                    </IonButtons>
                    <IonTitle>Orders</IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent fullscreen>
                <CreateLeadOrder  />
            </IonContent>
        </IonPage>
    );
};

export default Order;
